import { render, staticRenderFns } from "./activityManager.vue?vue&type=template&id=2a24e0cf&scoped=true&"
import script from "./activityManager.ts?vue&type=script&lang=js&"
export * from "./activityManager.ts?vue&type=script&lang=js&"
import style0 from "./activityManager.less?vue&type=style&index=0&id=2a24e0cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a24e0cf",
  null
  
)

export default component.exports